import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Slide,
  Box,
  IconButton,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
//  MUI v7 + moment-jalaali
import { AdapterMomentJalaali } from "@mui/x-date-pickers/AdapterMomentJalaali";
import CloseIcon from "@mui/icons-material/Close";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import "./TimeFilterDialog.css";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const TimeFilterDialog = ({
  open,
  onClose,
  onConfirm,
  onClear,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMomentJalaali}>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        onClose={onClose}
        fullWidth
        maxWidth="xs"
        PaperProps={{
          className: "time-filter-paper",
        }}
      >
        <div className="time-dialog-header">
          <IconButton onClick={onClose} size="small" className="close-btn">
            <CloseIcon fontSize="small" />
          </IconButton>
          <DialogTitle className="time-dialog-title">
            انتخاب بازه زمانی (شمسی)
          </DialogTitle>
        </div>

        <DialogContent className="time-dialog-content">
          <Box display="flex" flexDirection="column" gap={4} sx={{ mt: 2 }}>
            {/* Start Date Picker */}
            <div className="date-field-group">
              <label className="date-field-label">از تاریخ</label>
              <DatePicker
                value={startDate}
                onChange={(newValue) => setStartDate(newValue)}
                disableFuture
                format="jYYYY/jMM/jDD"
                slots={{
                  openPickerIcon: CalendarMonthIcon,
                }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    className: "shamsi-date-input",
                    placeholder: "۱۴۰۲/۰۱/۰۱",
                  },
                }}
              />
            </div>

            {/* End Date Picker */}
            <div className="date-field-group">
              <label className="date-field-label">تا تاریخ</label>
              <DatePicker
                value={endDate}
                onChange={(newValue) => setEndDate(newValue)}
                disableFuture
                minDate={startDate}
                format="jYYYY/jMM/jDD"
                slots={{
                  openPickerIcon: CalendarMonthIcon,
                }}
                slotProps={{
                  textField: {
                    fullWidth: true,
                    className: "shamsi-date-input",
                    placeholder: "۱۴۰۲/۱۲/۲۹",
                  },
                }}
              />
            </div>
          </Box>
        </DialogContent>

        <DialogActions className="time-dialog-actions">
          <Button
            onClick={() => {
              setStartDate(null);
              setEndDate(null);
              onConfirm();
            }}
            variant="outlined"
            className="show-all-btn"
          >
            نمایش همه
          </Button>
          <Button
            onClick={onConfirm}
            variant="contained"
            className="confirm-btn"
          >
            تایید و اعمال
          </Button>
          <Button onClick={onClear} variant="text" className="clear-btn">
            پاکسازی
          </Button>
        </DialogActions>
      </Dialog>
    </LocalizationProvider>
  );
};

export default TimeFilterDialog;
